export enum SearchType {
  SQUARE = "square",
  ROUND = "round",
  UNDERLINE = "underline"
}

export const SearchDefaultIconNames: {
  layout: string;
  primary: string;
  secondary: string;
} = {
  layout: "",
  primary: "Search",
  secondary: "Clear Search"
};
